import { render, staticRenderFns } from "./ItemDDL.vue?vue&type=template&id=0502abe0&scoped=true"
import script from "./ItemDDL.vue?vue&type=script&lang=js"
export * from "./ItemDDL.vue?vue&type=script&lang=js"
import style0 from "./ItemDDL.vue?vue&type=style&index=0&id=0502abe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502abe0",
  null
  
)

export default component.exports